module.exports = __webpack_public_path__ + "img/ubuntu-bleu@2x.56bc2c15.png";